/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainPushNotificationsTokensPushNotificationPlatform;
(function (FxIdDomainPushNotificationsTokensPushNotificationPlatform) {
    FxIdDomainPushNotificationsTokensPushNotificationPlatform[FxIdDomainPushNotificationsTokensPushNotificationPlatform["Ios"] = 0] = "Ios";
    FxIdDomainPushNotificationsTokensPushNotificationPlatform[FxIdDomainPushNotificationsTokensPushNotificationPlatform["Android"] = 1] = "Android";
    FxIdDomainPushNotificationsTokensPushNotificationPlatform[FxIdDomainPushNotificationsTokensPushNotificationPlatform["Web"] = 2] = "Web";
    FxIdDomainPushNotificationsTokensPushNotificationPlatform[FxIdDomainPushNotificationsTokensPushNotificationPlatform["Steam"] = 3] = "Steam";
    FxIdDomainPushNotificationsTokensPushNotificationPlatform[FxIdDomainPushNotificationsTokensPushNotificationPlatform["WindowsStore"] = 4] = "WindowsStore";
    FxIdDomainPushNotificationsTokensPushNotificationPlatform[FxIdDomainPushNotificationsTokensPushNotificationPlatform["Amazon"] = 5] = "Amazon";
    FxIdDomainPushNotificationsTokensPushNotificationPlatform[FxIdDomainPushNotificationsTokensPushNotificationPlatform["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainPushNotificationsTokensPushNotificationPlatform || (FxIdDomainPushNotificationsTokensPushNotificationPlatform = {}));
export function instanceOfFxIdDomainPushNotificationsTokensPushNotificationPlatform(value) {
    for (const key in FxIdDomainPushNotificationsTokensPushNotificationPlatform) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainPushNotificationsTokensPushNotificationPlatform, key)) {
            if (FxIdDomainPushNotificationsTokensPushNotificationPlatform[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainPushNotificationsTokensPushNotificationPlatformFromJSON(json) {
    return FxIdDomainPushNotificationsTokensPushNotificationPlatformFromJSONTyped(json, false);
}
export function FxIdDomainPushNotificationsTokensPushNotificationPlatformFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainPushNotificationsTokensPushNotificationPlatformToJSON(value) {
    return value;
}
export function FxIdDomainPushNotificationsTokensPushNotificationPlatformToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainPushNotificationsTokensPushNotificationPlatform.js.map